// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-input__prepend-inner{margin-top:auto!important;margin-bottom:auto!important}.dropdown-menu.v-menu__content{background-color:#fff!important}.dropdown-menu .v-list{background-color:transparent!important}.scrollbar::-webkit-scrollbar{width:9px}.scrollbar::-webkit-scrollbar-track{background:transparent}.scrollbar::-webkit-scrollbar-thumb{background-color:#eff0fd;border-radius:20px}", ""]);
// Exports
module.exports = exports;
